import { NotificationStyleEnum } from '@/types/enums/notification/notification-style.enum';
import { PayoutTypesEnum } from 'types/enums/forms/account/payoutTypes';

export interface IAccountPersonalDetails {
    firstName: string;
    lastName: string;
    countryCode: string;
    zip: string;
    stateCode: string;
    city: string;
    address1: string;
    address2: string;
    timezoneId: number;
    preferredLanguageId: number | null;
    marketResearch?: boolean;
    nameAddressDisabled: boolean;
}

export interface IAccountProfessionalDetails {
    professionId: number | null;
    specialtyId: number | null;
    medicalSchool: string | null;
    graduationYear: number | null;
    primaryWorkplaceName?: string | null;
    workplaceMainlineNumber?: string | null;
}

export interface IAccountContactFormDetails {
    email: string | undefined;
    emailCode: string | undefined;
    mobilePhone: string | undefined;
    mobilePhoneCode: string | undefined;
    mobilePhoneCodeId: number | undefined;
    alternativePhone1: string | undefined;
    alternativePhone2: string | undefined;
    SMSOptIn: boolean | undefined;
}

export interface IAccountContactDetails extends IAccountContactFormDetails {
    mobilePhoneCodeId: number;
    pendingEmail: string | undefined;
    isEmailConfirmed: boolean;
    isMobilePhoneConfirmed: boolean;
    isMobilePhoneOptional: boolean;
}

export interface IAllAccountData
    extends Partial<IAccountPersonalDetails>,
        Partial<IAccountProfessionalDetails>,
        Partial<IAccountContactDetails> {
    id: number;
    verificationStageId: number;
    verificationRequestToken: string;
    invoicePageType?: PayoutTypesEnum;
}

export interface IAccountPasswordChange {
    currentPassword: string;
    newPassword: string;
    confirmNewPassword: string;
}

export interface IUserNotification {
    notificationId: number;
    style: NotificationStyleEnum;
    phraseId: number;
    isSnoozable: boolean;
    snoozeForMin: number | null;
    isDismissible: boolean;
    assignmentId: number;
}

export enum ExpertNetworkStatusEnum {
    INVITED = 'Invited',
    INVITE_EXPIRED = 'Invite Expired',
    REGISTERED = 'Registered',
    OPTED_OUT = 'Opted Out',
}

export interface IAccountSummary {
    userId: number;
    surveys: number;
    referrals: number | null;
    hasProfileQuestions: boolean;
    isEmailConfirmed: boolean;
    isVerificationRequired: boolean;
    isTaxableHonorariaThreshold: boolean;
    marketResearchInd: boolean;
    walletBalance: number;
    preferredLanguageId: number;
    countryCode: string;
    notifications: IUserNotification[];
    subpanelName: string | null | undefined;
    subpanelId: number | null | undefined;
    createDt: string | undefined;
    expertNetworkStatus?: ExpertNetworkStatusEnum | null;
}

export enum TaxType {
    EIN = 'EIN',
    SSN = 'SSN',
    ITIN = 'ITIN',
}

export interface IAccountTaxDetails {
    TIN: string | null;
    type: TaxType;
    fullName: string;
    lastName: string | null;
    address: string;
    city: string;
    stateCode: string;
    zip: string;
    isTaxableHonorariaThreshold: boolean;
}

export interface ITOTPData {
    totpToken: string;
    accountName: string;
    secretKey: string;
}

export interface IAccountInvoicingDetails {
    isRegistered?: boolean;
    name?: string;
    isVat?: boolean;
    vatNumber?: string;
    tin?: string;
    address?: string;
    address2?: string;
    city?: string;
    zip?: string;
    stateCode?: string;
    countryCode?: string;
    isChargeVat?: boolean | null;
    isElectronicInvoices?: boolean;
    pan?: string;
    aadhaar?: string;
    invoicePageType?: PayoutTypesEnum;
}
